import { spawn } from 'redux-saga/effects';
import cart from './cart/sagas';

export default function* sagas() {
	yield spawn(cart);
}
